module.exports = __webpack_public_path__ + "img/1481920700.c86504c0.jpg";